<template>
  <div class="el-col-24">
    <h5 class="warp-title">新增青豆用户信息</h5>
    <div class="chindleForm">
      <el-form :model="chindleForm" size="small" :rules="chindleRule" ref="chindleForm" class="my-form-style" label-position="left" label-width="auto" style="padding-left: 20px;">
        <el-form-item label="课程名" prop="courseName">
          <el-input v-model.trim="chindleForm.courseName" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="购买手机号" prop="buyPhone">
          <el-input v-model.trim="chindleForm.buyPhone" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="购买时间" prop="buyTime">
          <el-date-picker type="date" v-model="chindleForm.buyTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="购买金额" prop="buyAmount">
          <el-input v-model.trim="chindleForm.buyAmount" maxlength="10" class="w200"></el-input>
          <el-select v-model="chindleForm.unit" placeholder="" class="w80">
            <el-option label="元" :value="0"></el-option>
            <el-option label="学豆" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购买渠道" prop="buyChannel">
          <el-input v-model.trim="chindleForm.buyChannel" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="购买订单号" prop="buyOrderNumber">
          <el-input v-model.trim="chindleForm.buyOrderNumber" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="用户微信名" prop="userWechatName">
          <el-input v-model.trim="chindleForm.userWechatName" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="是否添加客服微信" prop="isAddWechat">
          <el-select v-model="chindleForm.isAddWechat" placeholder="请选择">
            <el-option label="是" :value="0"></el-option>
            <el-option label="否" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟进客服微信号" prop="customerWechat">
          <el-input v-model.trim="chindleForm.customerWechat" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="是否加入学习群" prop="isAddLearningGroup">
          <el-select v-model="chindleForm.isAddLearningGroup" placeholder="请选择">
            <el-option label="是" :value="0"></el-option>
            <el-option label="否" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动参与情况" prop="activityParticipation">
          <el-input v-model.trim="chindleForm.activityParticipation" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="活动礼品是否发放" prop="isActivityEventGifts">
          <el-select v-model="chindleForm.isActivityEventGifts" placeholder="请选择">
            <el-option label="是" :value="0"></el-option>
            <el-option label="否" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其他备注" prop="remark">
          <el-input v-model.trim="chindleForm.remark" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="是否发货" prop="isDeliverGoods">
          <el-select v-model="chindleForm.isDeliverGoods" placeholder="请选择">
            <el-option label="是" :value="0"></el-option>
            <el-option label="否" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="courierNumber" v-if="chindleForm.isDeliverGoods === 0">
          <el-input v-model.trim="chindleForm.courierNumber" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="收件人姓名" prop="consigneeName">
          <el-input v-model.trim="chindleForm.consigneeName" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="收件人手机号" prop="consigneePhone">
          <el-input v-model.trim="chindleForm.consigneePhone" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="收件人地址" prop="consigneeAddress">
          <el-input v-model.trim="chindleForm.consigneeAddress" maxlength="100"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="fixed-tab" :class="this.$store.state.Auth.collapse? 'fixed-tab-close': 'fixed-tab-open'">
      跟进状态：
      <el-radio-group v-model="handerStatus">
        <el-radio :label="1">未跟进</el-radio>
        <el-radio :label="2">跟进中</el-radio>
        <el-radio :label="3">已跟进</el-radio>
      </el-radio-group>
      <el-button type="primary" class="fr" @click="submitForm('chindleForm')" :loading="isSubmitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import {addChindleUserInfo} from '../../api/order/chindle'
import rule from '../../api/public/rule'
export default {
  name: 'OrderAddChindle',
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
  },
  components: {
  },
  data () {
    return {
      isSubmitLoading: false,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > (Date.now())
        }
      },
      handerStatus: 1,
      chindleForm: {
        courseName: '',
        buyPhone: '',
        buyAmount: '',
        buyChannel: '',
        buyOrderNumber: '',
        userWechatName: '',
        isAddWechat: '',
        customerWechat: '',
        isAddLearningGroup: '',
        activityParticipation: '',
        isActivityEventGifts: '',
        courierNumber: '',
        remark: '',
        isDeliverGoods: '',
        consigneeName: '',
        consigneePhone: '',
        consigneeAddress: '',
        buyTime: '',
        unit: 0
      },
      chindleRule: {
        courseName: [
          { required: true, message: '请输入课程名称', trigger: ['blur', 'change'] }
        ],
        buyPhone: [
          {required: true, message: '请输入购买手机号码', trigger: ['blur', 'change']},
          {pattern: rule.mobile, message: '手机号格式错误，请检查', trigger: ['blur', 'change']}
        ],
        buyAmount: [
          { required: true, message: '请输入购买金额', trigger: ['blur', 'change'] },
          {pattern: rule.positive, message: '请输入0.00-99999.99的数值，仅限两位小数', trigger: ['blur', 'change']}
        ],
        buyChannel: [
          { required: true, message: '请输入购买渠道', trigger: ['blur', 'change'] }
        ],
        buyOrderNumber: [
          { required: true, message: '请输入购买订单号', trigger: ['blur', 'change'] },
          {pattern: rule.letter, message: '只能输入字母，数字', trigger: ['blur', 'change']}
        ],
        userWechatName: [
          { required: true, message: '请输入用户微信名', trigger: ['blur', 'change'] }
        ],
        isAddWechat: [
          { required: true, message: '请选择是否添加客服微信', trigger: 'change' }
        ],
        customerWechat: [
          { required: true, message: '请输入跟进客服微信号', trigger: ['blur', 'change'] }
        ],
        isAddLearningGroup: [
          { required: true, message: '请选择是否加入学习群', trigger: 'change' }
        ],
        activityParticipation: [
          { required: true, message: '请输入活动参与情况', trigger: ['blur', 'change'] }
        ],
        isActivityEventGifts: [
          { required: true, message: '请选择活动礼品是否发放', trigger: 'change' }
        ],
        courierNumber: [
          { required: true, message: '请输入快递单号', trigger: ['blur', 'change'] }
        ],
        remark: [
          { required: true, message: '请输入其他备注', trigger: ['blur', 'change'] }
        ],
        isDeliverGoods: [
          { required: true, message: '请选择是否发货', trigger: 'change' }
        ],
        consigneeName: [
          { required: true, message: '请输入收件人姓名', trigger: ['blur', 'change'] }
        ],
        consigneePhone: [
          {required: true, message: '请输入收件人手机号码', trigger: ['blur', 'change']},
          {pattern: rule.mobile, message: '手机号格式错误，请检查', trigger: ['blur', 'change']}
        ],
        consigneeAddress: [
          { required: true, message: '请输入收件人地址', trigger: ['blur', 'change'] }
        ],
        buyTime: [
          { type: 'string', required: true, message: '请选择购买时间', trigger: 'change' }
        ]
      },
      teaOption: [],
      subjectOption: [],
      difficultyOption: [],
      questionOption: [],
      labelOption: [],
      gradeOption: [],
      timeData: [{
        classDate: '',
        startTime: '',
        endTime: ''
      }]
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            handerStatus: this.handerStatus,
            courseName: this.chindleForm.courseName,
            buyPhone: this.chindleForm.buyPhone,
            buyTime: this.chindleForm.buyTime,
            buyAmount: this.chindleForm.buyAmount,
            unit: this.chindleForm.unit,
            buyChannel: this.chindleForm.buyChannel,
            buyOrderNumber: this.chindleForm.buyOrderNumber,
            userWechatName: this.chindleForm.userWechatName,
            isAddWechat: this.chindleForm.isAddWechat,
            customerWechat: this.chindleForm.customerWechat,
            isAddLearningGroup: this.chindleForm.isAddLearningGroup,
            activityParticipation: this.chindleForm.activityParticipation,
            isActivityEventGifts: this.chindleForm.isActivityEventGifts,
            remark: this.chindleForm.remark,
            isDeliverGoods: this.chindleForm.isDeliverGoods,
            courierNumber: this.chindleForm.courierNumber,
            consigneeName: this.chindleForm.consigneeName,
            consigneePhone: this.chindleForm.consigneePhone,
            consigneeAddress: this.chindleForm.consigneeAddress
          }
          this.isSubmitLoading = true
          addChindleUserInfo(data).then(info => {
            this.isSubmitLoading = false
            if (info.data.resultCode === 0) {
              this.$router.push({name: 'Chindle'})
            } else {
              this.$message.error(info.data.resultMessage)
            }
          }).catch(() => {
            this.isSubmitLoading = false
          })
        } else {
          this.scrollToFormError()
          return false
        }
      })
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
/deep/.el-form-item__label-wrap{
  margin-left: 0px!important;
}
.el-col-24{
  padding-bottom: 60px;
}
.el-button+.el-button{
  margin-left: 0;
}
.el-button--small{
  padding: 9px 10px;
}
.chindleForm {
  .el-select, .el-date-editor, .el-input{
    width: 300px;
  }
  .w200{
    width: 215px;
  }
  .w80{
    width: 80px;
  }
}
.fixed-tab{
  position: fixed;
  bottom: 0;
  right: 20px;
  transition: all 0.5s;
  background: #EBEEF5;
  padding: 10px 20px;
  font-size: 14px;
  line-height: 40px;
  .el-button{
    margin-left: 10px;
  }
}
.fixed-tab-open{
  left: 210px;
}
.fixed-tab-close{
  left: 65px;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/AddChindle.vue